<template>
  <div class="c-accordion">
    <div
      class="o-typography--action c-accordion__header"
      @click="toggle"
    >
      <slot name="header"></slot>
    </div>
    <v-collapse
      class="c-accordion__content"
      :expanded="isExpanded"
    >
      <slot name="content"></slot>
    </v-collapse>
  </div>
</template>
<script>
  import { VCollapse } from '@/index/shared/components';

  export default {
    components: {
      VCollapse,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isExpanded: this.value,
      };
    },
    methods: {
      toggle() {
        this.isExpanded = !this.isExpanded;
        this.$emit('input', this.isExpanded);
      },
    },
  };
</script>
